import client from "./httpClient";
import { SERVER_URL } from "../constants/Api";

export const sendSupport = async ({
  supportRequest,
  userEmail,
  grecaptchaToken
}) => {
  const response = await client
    .post(`${SERVER_URL}/api/v1/send_support`, {
      json: {
        user_email: userEmail,
        support_request: supportRequest,
        grecaptcha_token: grecaptchaToken
      }
    }).json();
  
  // This is needed because the endpoint doesn't return a 404 if the user couldn't be created,
  // but instead returns a 200 JSON response with a body of { status: 404 }...
  if (response.status !== 200) {
    throw new Error("Something went wrong");
  }
};
